module.exports = __webpack_public_path__ + "static/media/Hanna Ansar Koloth.00606c98.jpg";